/*
 * @Description:
 * @Autor: yangx
 * @Date: 2025-06-17 18:32:34
 */
import Vue from 'vue'
import Vuex from 'vuex'
import gradeAnalysis from './modules/gradeAnalysis'
import lessonManage from './modules/lessonManage'
import examination from './modules/examination'
import arrangeCourse from './modules/arrangeCourse'
import schoolManage from './modules/schoolManage'
import enrollment from './modules/enrollment'
import leaveSchoolManagement from './modules/leaveSchoolManagement'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    gradeAnalysis,
    lessonManage,
    examination,
    arrangeCourse,
    schoolManage,
    enrollment,
    leaveSchoolManagement
  },
  getters
})

export default store
